// @flow

import { SET_JWT, SET_MODERATOR_JWT } from "./actionTypes";

/**
 * Stores a specific JSON Web Token (JWT) into the redux store.
 *
 * @param {string} [jwt] - The JSON Web Token (JWT) to store.
 * @returns {{
 *     type: SET_TOKEN_DATA,
 *     jwt: (string|undefined)
 * }}
 */
export function setJWT(jwt: ?string) {
    return {
        type: SET_JWT,
        jwt,
    };
}
/**
 * Stores a specific JSON Web Token (JWT) into the redux store.
 *
 * @param {boolean} [val] - The JSON Web Token (JWT) to store.
 * @returns {{
 *     type: SET_MODERATOR_JWT,
 *     jwt: boolean
 * }}
 */
export function setModeratorJwt(val) {
    return {
        type: SET_MODERATOR_JWT,
        val,
    };
}
